import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { motion, MotionProps } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Clear';

export const HoverableCloseButton = ({
  sx,
  ...props
}: IconButtonProps & MotionProps) => (
  <IconButton
    component={motion.button}
    whileHover={{
      rotate: '90deg'
    }}
    sx={{
      background: 'transparent!important',
      ...sx
    }}
    {...props}
  >
    <CloseIcon />
  </IconButton>
);
